import AttributeActions from '../actions/AttributeCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import AttributeModel from '../model/AttributeModel';
import { normalizeVariableName } from '../helpers/variable-names-helper';

export type AttributeState = {
  busy: boolean;
  entities: AttributeModel[];
  businessEntities: AttributeModel[];
};

const initialState: AttributeState = {
  entities: [],
  businessEntities: [],
  busy: false,
};

export default function attribute(state = initialState, action) {
  switch (action.type) {
    case AttributeActions.busyAction:
      return setBusy(state);
    case AttributeActions.retrievedAllAction: {
      return {
        ...state,
        busy: false,
        entities: action.entities.map((entity: AttributeModel) => ({
          ...entity,
          friendlyName: normalizeVariableName(
            entity.friendlyName ? entity.friendlyName : entity.name,
          ),
        })),
      };
    }
    case AttributeActions.retriveBusinessAttributesAction:
      return {
        ...state,
        businessEntities: action.payload,
        busy: false,
      };
    case Actions.RESET:
      return initialState;
    case AttributeActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
}
